// Central data-testid registry for VISION marketing site
export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkPillars: "nav-link-pillars",
  linkCollection: "nav-link-collection",
  linkJournal: "nav-link-journal",
  linkContact: "nav-link-contact",
  shopBtn: "nav-shop-button",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  sub: "hero-subheadline",
  exploreBtn: "hero-explore-button",
  shopBtn: "hero-shop-button",
};

export const ABOUT = { root: "about-section" };

export const PILLARS = {
  root: "pillars-section",
  card: (slug) => `pillar-card-${slug}`,
};

export const COLLECTION = {
  root: "collection-section",
  card: (slug) => `collection-card-${slug}`,
  shopNow: (slug) => `collection-shop-${slug}`,
  viewAll: "collection-view-all",
};

export const JOURNAL = {
  root: "journal-section",
  card: (i) => `journal-card-${i}`,
};

export const PLAYLIST = {
  root: "playlist-section",
  card: (i) => `playlist-card-${i}`,
};

export const COMMUNITY = { root: "community-section" };

export const NEWSLETTER = {
  root: "newsletter-section",
  form: "newsletter-form",
  input: "newsletter-email-input",
  submit: "newsletter-submit-button",
  success: "newsletter-success",
  error: "newsletter-error",
};

export const CONTACT = {
  root: "contact-section",
  instagram: "contact-instagram",
  email: "contact-email",
  faq: (i) => `faq-item-${i}`,
};

export const FOOTER = { root: "footer-section" };

export const LOADER = { root: "splash-loader" };
